import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import "./Slider.css";

export default function CustomSlider({
  dots = true,
  infinite = false,
  speed = 500,
  slidesToShow = 3,
  slidesToScroll = 3,
  centerMode = false,
  responsiveSettings = [
    {
      breakpoint: 1300,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        variableWidth: true,
        centerMode: false,
      },
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1.3,
        slidesToScroll: 1,
        centerMode: true,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1.1,
        slidesToScroll: 1,
        centerMode: true,
      },
    },
    {
      breakpoint: 640,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false,
      },
    },
  ],
  children,
}) {
  const settings = {
    dots,
    infinite,
    speed,
    slidesToShow,
    slidesToScroll,
    responsive: responsiveSettings,
    centerMode,
  };

  return (
    <div className="slider">
      <Slider {...settings}>
        {children} {/* Render children within the Slider component */}
      </Slider>
    </div>
  );
}
